import { Space } from 'antd'
import { EmailTemplateButton } from './EmailTemplateButton'

const PreeventViewer = function () {
  return <Space size='small' orientation='vertical'>
    <p>Viewer pre-event email templates</p>
    <EmailTemplateButton type='Pre-event - Viewer' title='Registration confirmation' settingKey='pre-session.viewer.registration' />
    <EmailTemplateButton type='Pre-event - Viewer' title='Login details' settingKey='pre-session.viewer.login-details' />
  </Space>
}

export default PreeventViewer
